import * as React from "react";
import auth from "../../Auth";
import WithoutFilterColumnMenu from "../GridComponents/WithoutFilterColumnMenu";
import { CellRender, GridNoRecord } from "../GridComponents/CommonComponents";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { toODataString } from "@progress/kendo-data-query";
import { GridDetailRow } from "@progress/kendo-react-grid";
import { initialDataState,  errorToastr } from "../../../HelperMethods";
import { KendoFilter } from "../../ReusableComponents";
import { process } from "@progress/kendo-data-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { getReqShiftsbyReqIdService , getShiftTypesService} from "../../Requisitions/CreateRequisition/Shifts/Services";

export interface ViewShiftsProps {
  reqId: string;
  targetStartDate: any;
  targetEndDate: any;
  positionName?: string;
  positionId?: string;
  noOfPositions?: number;
  locationId?: string;
  locationName?: string;
  departmentId?: string;
  departmentName?: string;
}

export interface ViewShiftsState {
  data: any;
  clientId: string;
  showLoader?: boolean;
  dataState: any;
  totalCount?: number;
  shifts: Array<any>;
  shiftTypes: Array<{ id: string; name: string }>;
}

// Simple detail view component for expanded rows
class ViewMoreComponent extends GridDetailRow {
  render() {
    const dataItem = this.props.dataItem;
    return <DetailView {...dataItem} />;
  }
}

// Detail view component to show additional information
const DetailView = (props) => {
  return (
    <div className="row">
      <div className="col-12 col-lg-12 text-dark">
        <div className="row ml-0 mr-0 mt-1">
          <div className="col-12 pl-0 text-right">
            <div className="row mb-2">
              <div className="col-7">
                <label className="mb-0">Duration:</label>
              </div>
              <div className="col-5 text-left pl-0 pr-0">
                <label className="text-overflow_helper-label-modile-desktop mb-0">
                  {props.duration ? props.duration : "-"}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Detail column cell for expanding rows
class DetailColumnCell extends React.Component<{
  dataItem: any;
  expandChange: any;
}> {
  render() {
    let dataItem = this.props.dataItem;
    return (
      <td contextMenu="View More" style={{ textAlign: "center" }}>
        <FontAwesomeIcon
          icon={faList}
          style={{
            marginLeft: "0px!important",
            marginTop: "0",
            fontSize: "16px",
          }}
          className={"active-icon-blue left-margin cursorPointer"}
          onClick={() => this.props.expandChange(dataItem)}
        />
      </td>
    );
  }
}

class ViewShifts extends React.Component<ViewShiftsProps, ViewShiftsState> {
  constructor(props: ViewShiftsProps) {
    super(props);
    this.state = {
      data: [],
      clientId: auth.getClient(),
      dataState: initialDataState,
      showLoader: true,
      shifts: [],
      shiftTypes: [],
    };
  }

  componentDidMount() {
    this.getShiftTypes();

    if (this.props.reqId) {
      this.loadShiftsFromDatabase(this.state.dataState);
    } else {
      this.setState({
        showLoader: false,
        data: [],
      });
    }
  }

  loadShiftsFromDatabase = (dataState) => {   
    this.setState({ showLoader: true });
    var queryStr = `${toODataString(dataState, { utcDates: true })}`;
    let queryParams = `reqId eq ${this.props.reqId}`;

    var finalQueryString = KendoFilter(dataState, queryStr, queryParams);
    getReqShiftsbyReqIdService(this.props.reqId, finalQueryString)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          // Process the shifts to match our shift format
          const dbShifts = res.data.map((shift) => {
            return {
              ...shift,
              id: shift.reqShiftId,
            };
          });

          this.setState({ shifts: dbShifts }, () => {
            this.getShifts(this.state.dataState);
          });
        } else {
          this.setState({
            showLoader: false,
            data: [],
          });
        }
      })
      .catch((error) => {
        errorToastr("Error loading shifts from database");
        this.setState({ showLoader: false });
      });
  };

  getShifts = (dataState) => {
    this.setState({ showLoader: true });

    // Process the data with the Kendo UI DataQuery
    const processedShifts = this.state.shifts.map((shift) => {
      // Create a copy of the shift
      const processedShift = { ...shift };

      // Ensure each item has an ID for grid operations
      if (!processedShift.id) {
        processedShift.id = processedShift.reqShiftId;
      }

      return processedShift;
    });

    // Apply the Kendo UI DataQuery operations (sorting, filtering, paging)
    const result = process(processedShifts, dataState);

    this.setState({
      data: result.data,
      dataState: dataState,
      totalCount: result.total,
      showLoader: false,
    });
  };

  expandChange = (dataItem) => {
    const { data } = this.state;
    const shiftsData = data.map((item) => {
      if (item === dataItem) {
        item.expanded = !item.expanded;
      }
      return item;
    });
    this.setState({
      data: shiftsData,
    });
  };

  onDataStateChange = (changeEvent) => {
    this.getShifts(changeEvent.dataState);
  };

  ExpandCell = (props) => (
    <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />
  );

  getShiftTypes = () => {
      getShiftTypesService().then((res) => {
        if (res.data) {
          this.setState({ shiftTypes: res.data });
        }
      });
    };

  render() {
    return (
      <div className="row mt-3 mt-md-0">
        <div className="container-fluid">
          <div className="cand-bill-rate" id="cand-bill-rate-responsive">
            <Grid
              style={{ height: "auto" }}
              sortable={true}
              onDataStateChange={this.onDataStateChange}
              pageable={{ pageSizes: true }}
              data={this.state.data}
              {...this.state.dataState}
              total={this.state.totalCount}
              detail={ViewMoreComponent}
              expandField="expanded"
              className="kendo-grid-custom k-widget lastchild"
              filterable={false}
              columnMenu={false}
            >
              <GridNoRecords>
                {GridNoRecord(this.state.showLoader)}
              </GridNoRecords>

              {/* <GridColumn
                field="expanded"
                title=""
                width="50px"
                cell={this.ExpandCell}
                            /> */}
              <GridColumn
                field="name"
                title="Shift Name"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) => CellRender(props, "Shift Name")}
              />
              <GridColumn
                field="shiftTypeId"
                title="Shift Type"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) => {
                  const shiftType = this.state.shiftTypes.find(
                    type => type.id === props.dataItem.shiftTypeId
                  );
                  return <td>{shiftType ? shiftType.name : ''}</td>;
                }}
             />
              <GridColumn
                field="capacity"
                title="No of Positions"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) => (
                  <td className="text-right">
                    {props.dataItem[props.field] || "-"}
                  </td>
                )}
              />
              <GridColumn
                field="startDate"
                filter="date"
                format="{0:d}"
                editor="date"
                title="Start Date"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) => CellRender(props, "Start Date")}
              />
              <GridColumn
                field="endDate"
                filter="date"
                format="{0:d}"
                editor="date"
                title="End Date"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) => CellRender(props, "End Date")}
              />
              <GridColumn
                field="startTime"
                filter="date"
                format="{0:d}"
                editor="date"
                title="Start Time"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) =>
                  CellRender(props, "Start Time", null, null, true)
                }
                width="125px"
              />
              <GridColumn
                field="endTime"
                filter="date"
                format="{0:d}"
                editor="date"
                title="End Time"
                columnMenu={WithoutFilterColumnMenu}
                cell={(props) =>
                  CellRender(props, "End Time", null, null, true)
                }
                width="125px"
              />     
               <GridColumn   width="5px"  />     
            </Grid>
          </div>
        </div> 
      </div>
    );
  }
}
export default ViewShifts;
